<template>
  <div class="optionitem">
    <img :src="image"> 
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  name:"Option",
  props:["text","image"]
}
</script>

<style scoped>
.optionitem{
  display: inline-flex;
  justify-items: center;
  flex-direction: column;
  align-items: center;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  box-shadow: 8px 8px 9px #e6e6e6;
  padding-top: 35px;
  padding-bottom: 45px;
  background-color: #fff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.3s ease;
}


.optionitem:hover {
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
}

img{
  width: 45px;
}

.optionitem:hover{
  cursor: pointer;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);

}

p{
  margin-bottom: 0;
  font-family: "Montserrat";
  color: #2650e7;
  font-size: 20px;
}

.optionitem p {
  font-size: 17px;
  padding-top: 5px;
}




@media only screen and (max-width:1350px) and (min-width: 768px) {

  .optionitem p {
    font-size: 17px;
  }

  .optionitem p {
      text-align: center;
      margin: 0 auto;
      width: 100%;
  }

  .desktopwrapper image img {
    width: 130px;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .optionitem img {
    width: 40px;
  }

}

@media only screen and (max-width: 767px) {

  img{
    width: 35px;
  }

  p{
    font-size: 15px;
  }

}
</style>